const upsertModalProps = (existingModals, modalProps) => {
    const index = existingModals.findIndex(element => element.id === modalProps.id);
    if (index === -1) {
        return [
            ...existingModals,
            modalProps
        ];
    }
    return existingModals.map((modal, i) => {
        if (i === index) {
            return modalProps;
        }
        return modal;
    });
};
export const guiStateUpdateModalReducer = (guiState, action) => (Object.assign(Object.assign({}, guiState), { modals: upsertModalProps(guiState.modals, action.payload.modalProps) }));
//# sourceMappingURL=reducer.js.map